import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import styles from './ImageDescription.module.scss';

const ImageDescription = ({ title = '', credits = '', caption = '' }) => {
    const { t } = useTranslation('common');
    return (
        <div className={styles['ImageDescription']}>
            <h3 className={styles['ImageDescription__Title']}>{title}</h3>
            {caption && <p className={styles['ImageDescription__Text']}>{caption}</p>}
            {credits && (
                <p className={styles['ImageDescription__Credits']}>
                    {t('imagegallery.photo')}: {credits}
                </p>
            )}
        </div>
    );
};

ImageDescription.propTypes = {
    title: PropTypes.string,
    credits: PropTypes.string,
    caption: PropTypes.string,
};

export default ImageDescription;
